if(!Util) { function Util () {} };

Util.addClass = function(el, className) {
  var classList = className.split(' ');
  el.classList.add(classList[0]);
  if (classList.length > 1) Util.addClass(el, classList.slice(1).join(' '));
};

Util.removeClass = function(el, className) {
  var classList = className.split(' ');
  el.classList.remove(classList[0]);
  if (classList.length > 1) Util.removeClass(el, classList.slice(1).join(' '));
};

Util.toggleClass = function(el, className, bool) {
  if(bool) Util.addClass(el, className);
  else Util.removeClass(el, className);
};

// File#: _2_checkout
// Usage: codyhouse.co/license
(function() {
  // update billing info visibility
  var billingCheckBox = document.getElementsByClassName('js-billing-checkbox');
  if(billingCheckBox.length > 0) {
    var billingInfo = document.getElementsByClassName('js-billing-info');
    if(billingInfo.length == 0) return;
    resetBillingInfo(billingCheckBox[0], billingInfo[0]);
    
    billingCheckBox[0].addEventListener('change', function(){
      resetBillingInfo(billingCheckBox[0], billingInfo[0]);
    });
  }

  function resetBillingInfo(input, content) {
    Util.toggleClass(content, 'block', !input.checked);
  };
}());